export default __webpack_public_path__ + "static/media/checkbox_unchecked.c9a35688.svg";